module.exports = __webpack_public_path__ + "media/images/brand/old-logo-fusic-60dc0fcd065a99db13928cd13dbeadc5.svg";